import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const Text = styled(Typography)`
  color: ${(props) => props.color};
  text-transform: capitalize;
`;
export { Text };
